import { action } from 'satcheljs/lib/legacy';
import FolderStore from '../store/schema/FolderStore';
import Folder from '../store/schema/Folder';
import DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import { ObservableMap } from 'mobx';
import FolderId from 'owa-service/lib/contract/FolderId';
import MailboxLoadStateEnum from '../store/schema/MailboxLoadStateEnum';
import MailBoxData from '../store/schema/MailboxData';
import {
    ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID,
    PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID,
} from '../util/folderConstants';

export let folderStore: FolderStore = null;
let folderIdIncrementor = 0;
let folderNameToIdMap: { [key: string]: string };

export function getNextFolderId(): FolderId {
    return { Id: 'folderId' + (folderIdIncrementor++).toString(), ChangeKey: 'foo' };
}
export let addFolderToStore = function addFolderToStore(folder: Folder, isFavorite?: boolean) {
    folderStore.folderTable.set(folder.FolderId.Id, folder);
    if (folder.ParentFolderId) {
        folderStore.folderTable
            .get(folder.ParentFolderId.Id)
            .childFolderIds.push(folder.FolderId.Id);
    }

    if (folder.distinguishedFolderId) {
        folderNameToIdMap[folder.distinguishedFolderId] = folder.FolderId.Id;
    }
};

function addMailboxToStore(folder: Folder) {
    const primaryMailbox: MailBoxData = {
        id: PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID,
        rootFolder: folder,
        loadingState: MailboxLoadStateEnum.Uninitialized,
    };
    const archiveMailbox: MailBoxData = {
        id: ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID,
        rootFolder: null,
        loadingState: MailboxLoadStateEnum.Uninitialized,
    };
    folderStore.mailboxTable = new ObservableMap<string, MailBoxData>({
        [PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID]: primaryMailbox,
        [ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID]: archiveMailbox,
    });
}

addFolderToStore = action('addFolderToStore-TestMethod')(addFolderToStore);

export function resetFolderState(): void {
    folderNameToIdMap = {};
    let rootFolder: Folder = {
        DisplayName: 'Root folder',
        FolderClass: 'IPF.Note',
        FolderId: getNextFolderId(),
        ParentFolderId: null,
        childFolderIds: [],
        distinguishedFolderId: 'msgfolderroot',
    };

    let deletedItemsFolder: Folder = {
        DisplayName: 'Deleted items',
        FolderClass: 'IPF.Note',
        FolderId: getNextFolderId(),
        ParentFolderId: rootFolder.FolderId,
        childFolderIds: [],
        distinguishedFolderId: 'deleteditems',
    };

    let inbox: Folder = {
        DisplayName: 'Inbox',
        FolderClass: 'IPF.Note',
        FolderId: getNextFolderId(),
        ParentFolderId: rootFolder.FolderId,
        childFolderIds: [],
        distinguishedFolderId: 'inbox',
    };

    folderStore = {
        folderTable: new ObservableMap<string, FolderId>(),
        mailboxTable: new ObservableMap<string, MailBoxData>(),
        sharedFolderUserEmails: [],
    };

    addMailboxToStore(rootFolder);
    addFolderToStore(rootFolder);
    addFolderToStore(deletedItemsFolder);
    addFolderToStore(inbox);
}

export function folderNameToId(distinguishedFolderId: DistinguishedFolderIdName): string {
    return folderNameToIdMap[distinguishedFolderId];
}

export function getDistinguishedFolder(distinguishedFolderId: DistinguishedFolderIdName): Folder {
    return folderStore.folderTable.get(folderNameToId(distinguishedFolderId));
}

export function createAndAddFolderToStore(displayName: string, parentFolderId: string): Folder {
    let folder: Folder = {
        FolderId: getNextFolderId(),
        DisplayName: displayName,
        ParentFolderId: { Id: parentFolderId },
        FolderClass: 'IPF.Note',
        childFolderIds: [],
    };

    addFolderToStore(folder);

    return folder;
}
